import { Box } from '@mui/material';
import { ToolsDashbord } from '../../components/custom';
import { LayoutBase } from '../../layouts';
import { useEffect, useState } from 'react';
import { useAuthContext } from '../../context/AuthContext';
import { DamsServices, IDamsList } from '../../services/api/dams/DamServices';
import { ConsolidatedCard } from '../../components/shared';

export const Consolidated = () => {

    const { userData } = useAuthContext();

    console.log('user', userData);

    const [data, setData] = useState<IDamsList[]>([]);
    useEffect(() => {
        fecthData();
    }, [userData]);

    const fecthData = () => {
            DamsServices.get(userData.main_user ? userData.id_empresa : userData.uuid)
                .then((response => {
                    if(response instanceof Error){
                        console.log(response.message);
                    }else{
                        setData(response);
                    }
                }));

    };

    return (
        <LayoutBase title='Dados Consolidados'
            tollBar={<ToolsDashbord />}
        >
            <Box width={'100%'}>
                {data.map((index) => (
                    <ConsolidatedCard dam_uuid={index.uuid} key={index.uuid}/>
                ))}
            </Box>
        </LayoutBase>
    );
};